import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useDocumentTitle } from '@mantine/hooks';
import { HeaderMenu } from "../../components/HeaderMenu/HeaderMenu";
import { Container, Skeleton, Card, Group, Text, Space, Grid, Pagination, Flex } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import '../Funnel/Funnel.css';
import { notifications } from '@mantine/notifications';
import { VisiLoader, HelpTip } from "../../components/GeneralComponent/GeneralComponent";
import { UnsetWinner } from "../../components/ReviewTest/UnsetWinner";
import { PreviewStats } from "../../components/ReviewTest/PreviewStats";
import { ReviewPageList } from "../../components/ReviewTest/ReviewPageList";
import { ReviewPageGridList } from "../../components/ReviewTest/ReviewPageGridList";
import { ReviewPageOptions } from "../../components/ReviewTest/ReviewPageOptions";
import { AddToFunnel } from "../../components/ReviewTest/AddToFunnel";
import { TestCompletedWinner } from '../../components/ReviewTest/TestCompletedWinner';
import TestsApi from "../../api/TestsApi";

export function ReviewTests() {

	const navigate = useNavigate();
	
	useDocumentTitle("Visiopt - Review Tests");

	const [selectedMemberWebsite, setSelectedMemberWebsite] = useState('');

	const handleHeaderMenuComponentChange = (Value:any) => {
	  setSelectedMemberWebsite(Value);
	};
	const [loading, setLoading] = useState(false);
	const [SystemUsageLoader, setSystemUsageLoader] = useState(false);
	const [selectedAllTestPageValue, setSelectedAllTestPageValue] = useState('0');
	const [activePageNo, setActivePageNo] = useState(1);
	const [keyword, setKeyword] = useState('');
	const [selectPageTests, setSelectPageTests] = useState([]);
	const [totalPages, setTotalPages] = useState(10);
	const [totalPaginationNo, setTotalPaginationNo] = useState(1);
	const [selectedThumbnail, setSelectedThumbnail] = useState(null);
	const [selectedTaguchiTestId, setSelectedTaguchiTestId] = useState(null);
	const [selectedFunnelId, setSelectedFunnelId] = useState(null);
	const [selectedTestsId, setSelectedTestsId] = useState(null);
	const [isThumbnailSelected, setIsThumbnailSelected] = useState(false);
  const [viewSelect, setViewSelect] = useState('grid');
  const [showNumber, setShowNumber] = useState(25);
  const [marksalestime, setMarksalestime] = useState(0);
  const [openSetWinnerModel, setOpenSetWinnerModel] = useState(false);
  const [selectedPageClass, setSelectedPageClass] = useState(null);
  const [makeApiCall, setMakeApiCall] = useState(false);



  useEffect(() => {
  	if(selectedMemberWebsite !== ''){
	    setLoading(true);
	    TestsApi.getpageslist({
	      system_website_id: selectedMemberWebsite,
	      filter: selectedAllTestPageValue,
	      layout: viewSelect,
	      number: showNumber,
	      page: activePageNo,
	      keyword: keyword,
	    })
	    .then(response => {
	      if (response.ok) {
	        return response.json();
	      } else {
	        if (response.status === 401 || response.status === 400) {
	          setSystemUsageLoader(false);
	          navigate("/logout");
	        }
	      }
	    })
	    .then(data => {
	      if(data.status === 1){
	        if (data.data.test_pages_list) {
	          setSelectPageTests(data.data.test_pages_list);
	          if (data.data.active_page_no !== activePageNo) {
	            setActivePageNo(data.data.active_page_no);
	            setActivePageNo(1);
	          }
	          if (data.data.total_pages !== totalPages) {
	            setTotalPages(data.data.total_pages);
	          }
	          if (JSON.stringify(data.data.total_pagination_no) !== JSON.stringify(totalPaginationNo)) {
	            setTotalPaginationNo(data.data.total_pagination_no);
	          }
	        } else{
	          setSelectPageTests([]);
	        }
	      }else{
	        setSelectedAllTestPageValue('0');
	        notifications.show({
	          color: 'red',
	          icon: <IconX size="1.1rem" />,
	          title: 'Error',
	          message: data.message,
	        });
	      }
	      setLoading(false);
	    })
	    .catch(error => {
	      console.error("API Error:", error);
	      setLoading(false);
	    });
	  }
  }, [selectedAllTestPageValue, activePageNo, selectedMemberWebsite, viewSelect, showNumber, keyword, marksalestime, makeApiCall]);




  const handlePageChange = (newPage) => {
    setActivePageNo(newPage);
  };






  const handleSetWinnerCloseModal = () => {
    setOpenSetWinnerModel(false);
  };

	return (
	  <>
	  <VisiLoader VisiLoaderVisible={SystemUsageLoader}/>
	  <HeaderMenu HeaderMenuValue={selectedMemberWebsite} HeaderMenuOnChange={handleHeaderMenuComponentChange}/>
	  {openSetWinnerModel && (
	  	<TestCompletedWinner
	  		selectedMemberWebsite={selectedMemberWebsite}
	      pageId={selectedThumbnail}
	      openWinnerModal={openSetWinnerModel}
	      setWinnerModalOpen={setOpenSetWinnerModel}
	      setWinnerCloseModal={handleSetWinnerCloseModal}
	      systemUsageLoader={setSystemUsageLoader}
	      setMakeApiCall={setMakeApiCall}
	      setSelectedThumbnail={setSelectedThumbnail}
	    />
	  )}
	  <Container size="xl" mb={10}>
	  	<Card shadow="sm" padding="sm" radius="md" withBorder>
	  		<Group position="apart" mb="xs">
	        <Text weight={500}>REVIEW TESTS <HelpTip helpId={350} /></Text>
	      </Group>
  	    <ReviewPageOptions
  	    	ViewSelect={viewSelect}
			    ViewSelectChange={setViewSelect}
			    ShowNumberChange={setShowNumber}
			    ActivePageNo={setActivePageNo}
			    SelectedTestPageValue={setSelectedAllTestPageValue}
			    KeywordChange={setKeyword}
  	    />
  	    <div style={{flex: "1 1 auto",overflowX: "hidden",marginTop:10}}>
  	    	<div style={{ display: viewSelect === "grid" ? "block" : "none"}}>
  	    		{loading ? (
				      <Flex justify="start" gap="sm" mt={10} wrap="wrap">
				        {Array.from({ length: 21 }).map((_, index) => (
				          <Skeleton key={index} height={170} width={152} />
				        ))}
				      </Flex>
				    ) : (
					  	<>
					  	<ReviewPageGridList
					  		SelectedPageTests={selectPageTests}
						    SelectedThumbnail={selectedThumbnail}
						    SelectedThumbnailChange={setSelectedThumbnail}
						    IsThumbnailSelected={isThumbnailSelected}
						    IsThumbnailSelectedChange={setIsThumbnailSelected}
						    SelectedTaguchiIdChange={setSelectedTaguchiTestId}
						    SelectedFunnelIdChange={setSelectedFunnelId}
						    SelectedTestIdChange={setSelectedTestsId}
						    SelectedMemberWebsite={selectedMemberWebsite}
						    setOpenSetWinnerModel={setOpenSetWinnerModel}
						    setSelectedPageClass={setSelectedPageClass}
					  	/>
					  	{selectPageTests.some(item => Array.isArray(item) ? item.length > 0 : true) && (
						  <Pagination.Root total={totalPages} value={activePageNo} onChange={handlePageChange} >
						    <Group spacing={5} position="center" mb={20}>
						      <Pagination.First />
						      <Pagination.Previous />
						      <Pagination.Items />
						      <Pagination.Next />
						      <Pagination.Last />
						    </Group>
						  </Pagination.Root>
						  )}
						  </>
					  )}
				  </div>

		  	    {selectPageTests.some(item => Array.isArray(item) ? item.length > 0 : true) ? (
					  <div style={{ display: viewSelect === "list" ? "block" : "none"}}>
					  	{loading ? (
					  		<Flex direction="column" gap="sm" mt={10}>
			            {Array.from({ length: 12 }).map((_, index) => (
			              <Skeleton key={index} height={44} width={1262} />
			            ))}
			          </Flex>
					  	) : (
					  		<>
					  		<ReviewPageList
						  		SelectedPageTests={selectPageTests}
							    SelectedThumbnail={selectedThumbnail}
							    SelectedThumbnailChange={setSelectedThumbnail}
							    IsThumbnailSelected={isThumbnailSelected}
							    IsThumbnailSelectedChange={setIsThumbnailSelected}
							    SelectedTaguchiIdChange={setSelectedTaguchiTestId}
							    SelectedFunnelIdChange={setSelectedFunnelId}
							    SelectedTestIdChange={setSelectedTestsId}
							    setSelectedPageClass={setSelectedPageClass}
						  	/>
				  	    <Pagination.Root total={totalPages} value={activePageNo} onChange={handlePageChange} >
				  	      <Group spacing={5} position="center" mb={20}>
				  	        <Pagination.First />
				  	        <Pagination.Previous />
				  	        <Pagination.Items />
				  	        <Pagination.Next />
				  	        <Pagination.Last />
				  	      </Group>
				  	    </Pagination.Root>
				  	   	</>
					  	)}
					  </div>
			  	  ) : (
			  	  	<div style={{ display: viewSelect === "list" ? "block" : "none", height:180}}>
			  	  	</div>
			  	  )}
			  </div>
			  <div className="legend-holder">
				  <Grid>
		        <Grid.Col span={6} mt={15}>
		        	<Group spacing="xs" m={0}>
		        	  <span className="legend selected" />
		        	  <Text size="sm" ml={0} fz={12} className="legend-title">Selected</Text>
		        	  <span className="legend active" />
		        	  <Text size="sm" ml={0} fz={12} className="legend-title">Active Test</Text>
		        	  <span className="legend winner" />
		        	  <Text size="sm" ml={0} fz={12} className="legend-title">Winner Set</Text>
		        	  <span className="legend completed" />
		        	  <Text size="sm" ml={0} fz={12} className="legend-title">Test Completed</Text>
		        	  <span className="legend rotation" />
		        	  <Text size="sm" ml={0} fz={12} className="legend-title">Rotation Page</Text>
		        	</Group>
		        </Grid.Col>
		        <Grid.Col span={6}>
		        	<div style={{ display: viewSelect === "grid" ? "block" : "none"}}>
			        	<div style={{ display: 'flex'}}>
		              <Space w="xs" />
		              {selectedThumbnail && selectPageTests.find(item => item.page_id === selectedThumbnail && item.pageClass === 'page winner') ? (
									  <div style={{ display: 'flex', marginLeft: 'auto' }}>
									  	<PreviewStats
									  		SelectedThumbnail={selectedThumbnail}
												SystemUsageLoader={setSystemUsageLoader}
												SelectedMemberWebsite={selectedMemberWebsite}
									  	/>
									  	<UnsetWinner
									  		SelectedThumbnail={selectedThumbnail}
												SystemUsageLoader={setSystemUsageLoader}
												SelectedMemberWebsite={selectedMemberWebsite}
												MarkSalesTime={setMarksalestime}
									  	/>
									  </div>
									) : (
									  <>
									    <Space w="xs" />
									    <AddToFunnel
									    	SelectedThumbnail={selectedThumbnail}
												SelectedTaguchiId={selectedTaguchiTestId}
												SelectedMemberWebsite={selectedMemberWebsite}
												SelectedFunnelId={selectedFunnelId}
												SelectedTestId={selectedTestsId}
												setOpenSetWinnerModel={setOpenSetWinnerModel}
												selectedPageClass={selectedPageClass}
									    />
									  </>
									)}
		            </div>
		          </div>
		          <div style={{ display: viewSelect === "list" ? "block" : "none"}}>
		          	<div style={{ display: 'flex'}}>
		          		<Space w="xs" />
		          		{selectedThumbnail && selectPageTests.find(item => item.page_id === selectedThumbnail && item.type === 'Winner') ? (
									  <div style={{ display: 'flex', marginLeft: 'auto' }}>
									  	<PreviewStats
									  		SelectedThumbnail={selectedThumbnail}
												SystemUsageLoader={setSystemUsageLoader}
												SelectedMemberWebsite={selectedMemberWebsite}
									  	/>
									  	<UnsetWinner
									  		SelectedThumbnail={selectedThumbnail}
												SystemUsageLoader={setSystemUsageLoader}
												SelectedMemberWebsite={selectedMemberWebsite}
												MarkSalesTime={setMarksalestime}
									  	/>
									  </div>
									) : (
									  <>
									    <Space w="xs" />
									    <AddToFunnel
									    	SelectedThumbnail={selectedThumbnail}
												SelectedTaguchiId={selectedTaguchiTestId}
												SelectedMemberWebsite={selectedMemberWebsite}
												SelectedFunnelId={selectedFunnelId}
												SelectedTestId={selectedTestsId}
												setOpenSetWinnerModel={setOpenSetWinnerModel}
												selectedPageClass={selectedPageClass}
									    />
									  </>
									)}
		          	</div>
		          </div>
		        </Grid.Col>
		      </Grid>
			  </div>
			</Card>
	  </Container>
	  </>
	);
}